import { CommonConstants } from './common-constants.interface';

export const commonConstants: CommonConstants = {
  projectName: 'outages',
  isSubscribeGAPageNavigated: true,
  isProvidingChatBot: true,
  isProvidingGTM: true,
  signInUrl: '/pages/login.aspx',
  pageNotFound: '/Pages/PageNotFoundError.aspx',
  signOutUrl: '/pages/logout.aspx',
  mcsAuthVersion: () => sessionStorage.getItem('mcsAuthVersion'),
  accountDetailsUrl: () => 'auth' + sessionStorage.getItem('mcsAuthVersion') + '/accounts',
  checkOutageStatusUrl: '/powerOutages/outageTracker/userVerification',
  stormRestorationProcessUrl: '/Pages/AnonRedirect.aspx?Destination=/Outages/StormCenter/Pages/StormRestorationProcess.aspx',
  CoreServicesInitOptions: { additionalConfig: { } }
};
